import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.jpg";
import Work5 from "../../assets/work5.jpg";

export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "Frank Body Clone",
    content1:"Frank Body is an e-commerce  company,  It sells ",
    content2:"beauty, and Makeup products across websites...",
    category: "web",
    deploy_link:"https://darling-sorbet-a495bc.netlify.app/",
    github_link:"https://github.com/Mr-raaz/Frank_Body_Clone"
  },
  {
    id: 2,
    image: Work2,
    title: "Netmed's Clone",
    content1:"Netmeds.com is India’s most trusted Pharmacies,",
    content2:"dispensing quality medicines at reasonable...",
    category: "web",
    deploy_link:"https://symphonious-cucurucho-322130.netlify.app/",
    github_link:"https://github.com/Mr-raaz/netmeds_clone"
  },
  {
    id: 3,
    image: Work3,
    title: "Netmed's Clone",
    content1:"The site is focused on providing a market place ",
    content2:"for medicines and hygiene related products...",
    category: "web",
    deploy_link:"https://celebrated-brioche-bea6c1.netlify.app/index.html",
    github_link:"https://github.com/Mr-raaz/1Mg_Clone_Project"
  }
];

// projects
export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  },
  {
    name: "design",
  },
];
